import RowTabelaGerenciaPermissoes from "../RowTabelaGerenciaPermissoes/RowTabelaGerenciaPermissoes"
import "./TabelaGerenciaPermissoes.css"
import { logout } from "../../auth"
import { deleteMethod } from "../../services/api"

function TabelaGerenciaPermissoes({ authToken, page, numberOfPages, setPage, permissoes, setPermissoes, isTableLoading, refetchOptions }) {

    function deletePermission(idPermissao) {
        const idUsuarioAtual = localStorage.getItem("idusuario")

        if(typeof idUsuarioAtual === 'undefined') {
            logout()
        } else{
            const requestParams = {
                idPermissao: idPermissao,
                idUsuarioAtual: idUsuarioAtual
            }

            try{
                deleteMethod(
                    `/admin/permissoes?idPermissao=${requestParams.idPermissao}&idUsuarioAtual=${requestParams.idUsuarioAtual}`
                    , null, authToken
                );
                
                setPermissoes(permissoes => permissoes.filter(permissao => permissao.key != idPermissao))
                refetchOptions()
            } catch (error) {
                if (error.response) {
                    console.error('Erro na resposta do servidor:', error.response.data);
                } else if (error.request) {
                    console.error('Sem resposta do servidor:', error.request);
                } else {
                    console.error('Erro durante a configuração da requisição:', error.message);
                }
            } 
        }
    }

    return(
        <div className="manage-permissions-wrapper">
            <table id="table-manage-permissions">
                <thead>
                    <tr>
                        <th className="id-generico">Código</th>
                        <th className="organizacao">Organização</th>
                        <th className="nome">Nome</th>
                        <th className="setor">Setor</th>
                        <th className="papel">Papel</th>
                        <th className="acao">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    {isTableLoading &&  
                        <tr className="loading-table">
                            <td><span></span></td>
                        </tr>
                    }
                    {permissoes?.length > 0 
                        ? permissoes.map(permissao => 
                            <RowTabelaGerenciaPermissoes 
                                key={permissao.key} 
                                codigo={permissao.codigo} 
                                origem={permissao.origem} 
                                nome={permissao.descricao} 
                                setor={permissao.additional_data2} 
                                tipo={permissao.tipo} 
                                deletePermission={() => deletePermission(permissao.key)}
                            />
                        )
                        : !isTableLoading &&  
                            <tr>
                                <td className="sem-dados" colSpan={'100%'}><span>Não foram encontradas permissões com estes parâmetros!</span></td>
                            </tr>
                    }
                </tbody>
            </table>
            
           
        {numberOfPages > 0 && (
            <div className="pagination-controls">
                <button 
                    className="pagination-arrow" 
                    onClick={() => setPage(Math.max(1, page - 1))}
                    disabled={page === 1}
                    aria-label="Página anterior"
                >
                    &lt;
                </button>
                
                {(() => {
                    let startPage = page;
                    if (startPage > numberOfPages - 2) {
                        startPage = Math.max(1, numberOfPages - 2);
                    }
                    
                    const pageNumbers = [];
                    for (let i = 0; i < 3; i++) {
                        const pageNumber = startPage + i;
                        if (pageNumber <= numberOfPages) {
                            pageNumbers.push(pageNumber);
                        }
                    }
                    
                    return pageNumbers.map(num => (
                        <button 
                            key={num}
                            className={`pagination-number ${page === num ? 'active' : ''}`}
                            onClick={() => setPage(num)}
                            aria-label={`Página ${num}`}
                            aria-current={page === num ? 'page' : undefined}
                        >
                            {num}
                        </button>
                    ));
                })()}
                
                <button 
                    className="pagination-arrow" 
                    onClick={() => setPage(Math.min(numberOfPages, page + 1))}
                    disabled={page >= numberOfPages}
                    aria-label="Próxima página"
                >
                    &gt;
                </button>
            </div>
        )}
        </div>
    )
}

export default TabelaGerenciaPermissoes